import {
  COMPARATOR_CHANGE
} from "../constants/ActionTypes";

const INIT_STATE = {
  value:{}
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case COMPARATOR_CHANGE:
      return {...state,value:action.payload};
    default:
      return state;
  }
}
